import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zM5 1v22h14V1H5zm12 18H7V5h10v14z"
}), 'PermDeviceInformationSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PermDeviceInformationSharp.js
// module id = 5274
// module chunks = 2